// src/hooks/useTeamIdToClass.ts
import { useMemo } from 'react'

export type TeamClass = 'team-a' | 'team-b'

export function useTeamIdToClass(teamIds: number[] = []) {
  return useMemo(() => {
    const uniqueIds = Array.from(new Set(teamIds)).filter(Boolean)
    uniqueIds.sort() // consistent order

    return uniqueIds.reduce(
      (acc, id, index) => {
        acc[id] = index === 0 ? 'team-a' : 'team-b'
        return acc
      },
      {} as Record<string, TeamClass>
    )
  }, [teamIds])
}
